import { render } from "./InventoryPage.vue?vue&type=template&id=39b14763&scoped=true"
import script from "./InventoryPage.vue?vue&type=script&lang=js"
export * from "./InventoryPage.vue?vue&type=script&lang=js"

import "./InventoryPage.vue?vue&type=style&index=0&id=39b14763&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b14763"]])

export default __exports__